import type { VenueDescriptionSource } from '../../../../api/venues';

/** What saving will do to the venue's copy, given where the text comes from now. */
export function DescriptionSavingNote({ source }: { source: VenueDescriptionSource }) {
  if (source === 'fareharbor') {
    return (
      <>
        <strong style={{ fontWeight: 700 }}>Saving makes this Nebari&apos;s copy.</strong>{' '}
        FareHarbor syncs won&apos;t overwrite it — and that includes saving it empty.
      </>
    );
  }
  if (source === 'staff')
    return <>This is Nebari&apos;s copy. FareHarbor syncs don&apos;t change it.</>;
  return <>This venue is managed in Nebari, so FareHarbor doesn&apos;t sync this text.</>;
}
